import React from "react";
import moment from "moment-mini";

import withTranslations from "../../../../../hocs/withTranslations";
import Price from "../../../../../common/Price";
import { canAccessPaymentInvoices } from "../../../../../lib/payment/canAccessPaymentInvoices";
import ContentSection from "../../../common/ContentSection";
import Loader from "../../../common/Loader";
import SquaberButton from "../../../common/SquaberButton";
import SquaberLink from "../../../common/SquaberLink";
import SquaberTable from "../../../common/SquaberTable";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";
import InvoiceIcon from "../../../../components/landingPage/components/LandingTypography/assets/invoice_icon.svg";
import { PAYMENT_INVOICES_DEFAULT_LIMIT } from "../../../../../redux/modules/paymentInvoices";

const DOCUMENT_TYPE_TRANSLATION_KEYS = {
  invoice: "invoices_document_type_invoice",
  corrective: "invoices_document_type_corrective"
};

const renderInvoiceNumber = (invoice, translate) => {
  if (invoice.pdf_url) {
    return (
      <div className="flex items-center gap-1.5">
        <img
          className="shrink-0"
          src={InvoiceIcon}
          alt={translate("invoices_column_pdf")}
        />
        <SquaberLink to={invoice.pdf_url} target="_blank">
          {invoice.number}
        </SquaberLink>
      </div>
    );
  }

  return invoice.number ?? "-";
};

const InvoicesBox = ({
  translate,
  userData,
  paymentInvoices,
  fetchPaymentInvoices
}) => {
  const { loading, loadingMore, data = {} } = paymentInvoices ?? {};
  const { results = [], next = null } = data;
  const hasVerifiedEmail = canAccessPaymentInvoices(userData);

  const getDocumentTypeLabel = documentType => {
    const translationKey = DOCUMENT_TYPE_TRANSLATION_KEYS[documentType];

    return translationKey ? translate(translationKey) : documentType;
  };

  return (
    <ContentSection>
      <h2 className="big-heading">{translate("invoices_section_title")}</h2>
      {!hasVerifiedEmail ? (
        <p>{translate("invoices_verify_email_required")}</p>
      ) : loading && !results.length ? (
        <Loader small />
      ) : results.length ? (
        <LandingTypography>
          <SquaberTable
            withDistinctRows
            heading={[
              translate("invoices_column_number"),
              translate("invoices_column_document_type"),
              translate("invoices_column_issue_date"),
              translate("invoices_column_amount")
            ]}
            rows={results.map(invoice => [
              renderInvoiceNumber(invoice, translate),
              getDocumentTypeLabel(invoice.invoice_type),
              moment(invoice.issue_date).format("DD.MM.YYYY"),
              new Price({
                value: invoice.gross_amount,
                currency: invoice.currency
              }).render()
            ])}
          />
          {next ? (
            <div className="mt-4 text-center">
              <SquaberButton
                disabled={loadingMore}
                onClick={() => {
                  fetchPaymentInvoices({
                    offset: results.length,
                    limit: PAYMENT_INVOICES_DEFAULT_LIMIT,
                    append: true
                  });
                }}
              >
                {translate("More")}
              </SquaberButton>
            </div>
          ) : null}
        </LandingTypography>
      ) : (
        <p>{translate("invoices_empty_state")}</p>
      )}
    </ContentSection>
  );
};

export default withTranslations(InvoicesBox);
